import { render, staticRenderFns } from "./ResetPasswordView.vue?vue&type=template&id=3905571a&"
import script from "./ResetPasswordView.vue?vue&type=script&lang=ts&"
export * from "./ResetPasswordView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports